const submitFilters = () => {
  const form = document.querySelector('.c-search-bar__form');
  form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
};

export default submitFilters;
